import React, { Component } from 'react';
import { Flipper } from 'react-flip-toolkit';
import projectsData from './projectsData';
import Card from './Card';

export class Project extends Component {
  state = {
    active: 'All',
  };

  render() {
    let currentData = projectsData.filter((data) => {
      if (this.state.active === 'All') return data;
      return data.type === this.state.active;
    });

    const addClass = (filterMode) =>
      filterMode === this.state.active ? 'active' : '';

    return (
      <section className='section project' id='project'>
        <div className='pro'>
          <h3 className='h2 pro__heading'>Projects</h3>
          <div className='cardShow'>
            <ul className='filter-project'>
              <li
                className={addClass('All')}
                onClick={() => this.setState({ active: 'All' })}
              >
                <pre>All Project</pre>
              </li>
              <li
                className={addClass('Html')}
                onClick={() => this.setState({ active: 'Html' })}
              >
                <pre>Html,Css,js</pre>
              </li>
              <li
                className={addClass('React')}
                onClick={() => this.setState({ active: 'React' })}
              >
                <pre>React</pre>
              </li>
              <li
                className={addClass('full-stack')}
                onClick={() => this.setState({ active: 'full-stack' })}
              >
                <pre>Full Stack</pre>
              </li>
            </ul>
            <div className='gallery'>
              <Flipper flipKey={`${this.state.active}`} className='grid'>
                {currentData.map((data) => (
                  <Card data={data} key={data.id} />
                ))}
              </Flipper>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Project;
